const OutcomeLabelOverUnder = {
    title: 'Example JSON',
    expectedOutput: 'Arsenal 0.13',
    initialDisplayedCode: `{
    "outcomeId": 2950948551,
    "betOffer": {
      "id": 883929922,
      "betOfferType": {
      "id": 6,`,
    moreCode: `
    "name": "betOffer name"
    },
    "place": false,
    "outcomes": [
    {
        "id": 2950948551,
        "label": "Arsenal",
        "line": 130,
        "type": "OT_ONE_CROSS"
    },
    {
        "id": 2950948554,
        "label": "Feyenoord",
        "line": 230,
        "type": "OT_ONE_TWO"
    }
    ]
  },
  "event": {
    "awayName": "EventAwayName",
    "homeName": "EventHomeName"
  }
}`,
};

export default OutcomeLabelOverUnder;
